// City-specific content and culturally relevant phrases for each city

export const cityContentData = {
  'Bangalore': {
    state: 'Karnataka',
    phrases: {
      en: [
        'Solar Power in Bangalore - Bringing Power to Your Home',
        'Affordable Solar Power in Bangalore - Lunar Electric',
        'Professional Solar Power Installation in Bangalore',
        'Solar Power in Bangalore - Reduce Your Electricity Bill'
      ],
      kn: [
        'ಸೌರಶಕ್ತಿ ಬೆಂಗಳೂರಿನಲ್ಲಿ - ನಿಮ್ಮ ಮನೆಗೆ ಶಕ್ತಿಯನ್ನು ತರುವುದು',
        'ಬೆಂಗಳೂರಿನಲ್ಲಿ ಅಗ್ಗದ ಸೌರಶಕ್ತಿ - ಲೂನಾರ್ ಎಲೆಕ್ಟ್ರಿಕ್',
        'ಬೆಂಗಳೂರಿನಲ್ಲಿ ವೃತ್ತಿಪರ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆ',
        'ಬೆಂಗಳೂರಿನಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ವಿದ್ಯುತ್ ಬಿಲ್ ಕಡಿಮೆ ಮಾಡಿ'
      ]
    },
    description: 'Bangalore, the Silicon Valley of India, is leading the solar revolution. With abundant sunshine and growing awareness about renewable energy, more Bangaloreans are switching to solar power to reduce electricity bills and contribute to a greener future.',
    keywords: 'solar companies in Bangalore, solar panel installation Bangalore, rooftop solar Bangalore, solar energy Bangalore, solar power Bangalore, best solar company Bangalore, solar installation services Bangalore, residential solar Bangalore, commercial solar Bangalore',
    faqs: {
      en: [
        {
          q: 'Will rooftop solar actually help with Bangalore’s frequent power cuts?',
          a: 'Yes—pairing your solar plant with a small battery or a hybrid inverter keeps essentials running during outages. Even without batteries, your daytime consumption shifts to solar, cutting BESCOM bills noticeably.'
        },
        {
          q: 'How much roof space do I need in Bangalore?',
          a: 'Roughly 90–110 sq. ft. per kW on a typical RCC roof. A 3 kW system fits in about one car‑parking bay and covers an average apartment’s common‑area or a 2–3 BHK home’s daytime load.'
        },
        {
          q: 'Is net-metering smooth with BESCOM?',
          a: 'It is straightforward when the documentation is clean. We handle site survey, drawings, DISCOM submission and meter changeover, and keep you updated until synchronization.'
        }
      ],
      kn: [
        {
          q: 'ಬೆಂಗಳೂರುಿನಲ್ಲಿ ಆಗಾಗ್ಗೆ ನಡೆಯುವ ವಿದ್ಯುತ್ ಕಡಿತಕ್ಕೆ ರೂಫ್ಟಾಪ್ ಸೊಲಾರ್ ಸಹಾಯವಾಗುತ್ತದೆಯೇ?',
          a: 'ಹೌದು—ಸಣ್ಣ ಬ್ಯಾಟರಿ ಅಥವಾ ಹೈಬ್ರಿಡ್ ಇನ್‌ವೆರ್ಟರ್‌ ಜೊತೆಯಲ್ಲಿ ಜೋಡಿಸಿದರೆ ವಿದ್ಯುತ್ ವ್ಯತ್ಯಯದ ಸಮಯದಲ್ಲೂ ಅವಶ್ಯಕ ಲೋಡ್‌ಗಳು ಕಾರ್ಯನಿರ್ವಹಿಸುತ್ತವೆ. ಬ್ಯಾಟರಿ ಇಲ್ಲದಿದ್ದರೂ ದಿನದ ವೇಳೆಯ ಬಳಕೆ ಸೌರಶಕ್ತಿಗೆ ಶಿಫ್ಟ್ ಆಗಿ BESCOM ಬಿಲ್ ಗಮನಾರ್ಹವಾಗಿ ಕಡಿಮೆಯಾಗುತ್ತದೆ.'
        },
        {
          q: 'ಬೆಂಗಳೂರುಿನಲ್ಲಿ ನನಗೆ ಎಷ್ಟು ರೂಫ್ ಸ್ಪೇಸ್ ಬೇಕು?',
          a: 'ಸಾಮಾನ್ಯ RCC ಮಾಳಿಗೆಯಲ್ಲಿ ಪ್ರತಿ ಕಿ.ವ್ಯಾ.ಗೆ ಸುಮಾರು 90–110 ಚ.ಅ. ಅಗತ್ಯ. 3 ಕಿ.ವ್ಯಾ. ವ್ಯವಸ್ಥೆ ಒಂದು ಕಾರ್ ಪಾರ್ಕಿಂಗ್ ಬೇಯಲ್ಲಿ ಸರಾಗವಾಗಿ ಅಳವಡಿಸುತ್ತದೆ ಮತ್ತು ಸರಾಸರಿ ಅಪಾರ್ಟ್‌ಮೆಂಟ್‌ನ ಸಾಮಾನ್ಯ ಪ್ರದೇಶ ಅಥವಾ 2–3 BHK ಮನೆಯ ದಿನದ ಬೇಡಿಕೆಯನ್ನು ಪೂರೈಸುತ್ತದೆ.'
        },
        {
          q: 'BESCOM ನಲ್ಲಿ ನೆಟ್-ಮೀಟರಿಂಗ್ ಪ್ರಕ್ರಿಯೆ ಸುಲಭವಾಗಿದೆಯೇ?',
          a: 'ದಾಖಲೆಗಳು ಸರಿಯಾಗಿದ್ದರೆ ಪ್ರಕ್ರಿಯೆ ಸರಳ. ನಾವು ಸೈಟ್ ಸರ್ವೇ, ಡ್ರಾಯಿಂಗ್‌ಗಳು, ಡಿಸ್ಕಾಂ ಸಲ್ಲಿಕೆ ಮತ್ತು ಮೀಟರ್ ಬದಲಾವಣೆಯನ್ನು ನೋಡಿಕೊಳ್ಳುತ್ತೇವೆ ಮತ್ತು ಸಿಂಕ್ರೊನೈಸೇಶನ್‌ ಆಗುವವರೆಗೂ ನಿಮಗೆ ಅಪ್ಡೇಟ್ ಕೊಡುತ್ತೇವೆ.'
        }
      ]
    }
  },
  'Mysore': {
    state: 'Karnataka',
    phrases: {
      en: [
        'Solar Power in Mysore - Bringing Power to Your Home',
        'Affordable Solar Power in Mysore - Lunar Electric',
        'Professional Solar Power Installation in Mysore',
        'Solar Power in Mysore - Reduce Your Electricity Bill'
      ],
      kn: [
        'ಮೈಸೂರಿನಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ಮನೆಗೆ ಶಕ್ತಿಯನ್ನು ತರುವುದು',
        'ಮೈಸೂರಿನಲ್ಲಿ ಅಗ್ಗದ ಸೌರಶಕ್ತಿ - ಲೂನಾರ್ ಎಲೆಕ್ಟ್ರಿಕ್',
        'ಮೈಸೂರಿನಲ್ಲಿ ವೃತ್ತಿಪರ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆ',
        'ಮೈಸೂರಿನಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ವಿದ್ಯುತ್ ಬಿಲ್ ಕಡಿಮೆ ಮಾಡಿ'
      ]
    },
    description: 'Mysore, the cultural capital of Karnataka, is embracing solar energy. With its rich heritage and forward-thinking approach, Mysore residents are adopting solar panels to save on electricity costs while preserving the environment for future generations.',
    keywords: 'solar companies in Mysore, solar panel installation Mysore, rooftop solar Mysore, solar energy Mysore, solar power Mysore, best solar company Mysore, solar installation services Mysore, residential solar Mysore, commercial solar Mysore',
    faqs: [
      { q: 'Does Mysore’s weather suit solar?', a: 'Absolutely. Mysore gets consistent sunshine across the year. Systems deliver stable output even through monsoons thanks to high‑efficiency modules and proper tilt.' },
      { q: 'Can I install on a tiled or sloped roof?', a: 'Yes. We use specialized mounting structures that protect tiles and ensure wind resistance without compromising the look of your home.' },
      { q: 'What maintenance is needed?', a: 'A quick rinse every 2–4 weeks and an annual electrical check. We include 1‑year free maintenance and offer extended AMC if you prefer hands‑off care.' }
    ]
  },
  'Hubli': {
    state: 'Karnataka',
    phrases: {
      en: [
        'Solar Power in Hubli - Bringing Power to Your Home',
        'Affordable Solar Power in Hubli - Lunar Electric',
        'Professional Solar Power Installation in Hubli',
        'Solar Power in Hubli - Reduce Your Electricity Bill'
      ],
      kn: [
        'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ಮನೆಗೆ ಶಕ್ತಿಯನ್ನು ತರುವುದು',
        'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ಅಗ್ಗದ ಸೌರಶಕ್ತಿ - ಲೂನಾರ್ ಎಲೆಕ್ಟ್ರಿಕ್',
        'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ವೃತ್ತಿಪರ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆ',
        'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ವಿದ್ಯುತ್ ಬಿಲ್ ಕಡಿಮೆ ಮಾಡಿ'
      ]
    },
    description: 'Hubli, a major commercial hub in North Karnataka, is witnessing rapid growth in solar adoption. Businesses and homeowners in Hubli are choosing solar energy to reduce operational costs and ensure energy independence.',
    keywords: 'solar companies in Hubli, solar panel installation Hubli, rooftop solar Hubli, solar energy Hubli, solar power Hubli, best solar company Hubli, solar installation services Hubli, residential solar Hubli, commercial solar Hubli',
    faqs: {
      en: [
        { q: 'Can solar handle workshop or small‑industry loads in Hubli?', a: 'Yes. We design 10–100 kW commercial systems with proper string sizing and protection so machinery sees stable power and your monthly bill drops significantly.' },
        { q: 'Will dust reduce performance?', a: 'Hubli’s dust means cleaning is important. We plan access pathways and recommend a simple schedule to keep output near peak year‑round.' }
      ],
      kn: [
        { q: 'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ವರ್ಕ್‌ಶಾಪ್ ಅಥವಾ ಸಣ್ಣ ಕೈಗಾರಿಕಾ ಲೋಡ್‌ಗಳಿಗೆ ಸೊಲಾರ್ ಸಹಾಯವಾಗುತ್ತದೆಯೇ?', a: 'ಹೌದು. ಸರಿಯಾದ ಸ್ಟ್ರಿಂಗ್ ಸೈಜಿಂಗ್ ಮತ್ತು ರಕ್ಷಣೆಯೊಂದಿಗೆ 10–100 ಕಿ.ವ್ಯಾ. ವಾಣಿಜ್ಯ ವ್ಯವಸ್ಥೆಗಳನ್ನು ನಾವು ವಿನ್ಯಾಸಗೊಳಿಸುತ್ತೇವೆ; ಯಂತ್ರಗಳಿಗೆ ಸ್ಥಿರ ವಿದ್ಯುತ್ ಸಿಗುತ್ತದೆ ಮತ್ತು ತಿಂಗಳ ಬಿಲ್ ಬಹಳಷ್ಟು ಕಡಿಮೆಯಾಗುತ್ತದೆ.' },
        { q: 'ಧೂಳು ಕಾರ್ಯಕ್ಷಮತೆಯನ್ನು ಕಡಿಮೆ ಮಾಡುತ್ತದೆಯೇ?', a: 'ಹುಬ್ಬಳ್ಳಿಯಲ್ಲಿ ಧೂಳು ಹೆಚ್ಚು ಇರುವುದರಿಂದ ಕ್ಲೀನಿಂಗ್ ಮುಖ್ಯ. ನಾವು ಪ್ರವೇಶ ಮಾರ್ಗಗಳನ್ನು ಯೋಜಿಸಿ, ವರ್ಷಪೂರ್ತಿ ಔಟ್‌ಪುಟ್ ಗರಿಷ್ಠದ ಹತ್ತಿರ ಇರಲು ಸರಳ ಸ್ವಚ್ಛತಾ ವೇಳಾಪಟ್ಟಿಯನ್ನು ಶಿಫಾರಸು ಮಾಡುತ್ತೇವೆ.' }
      ]
    }
  },
  'Mangalore': {
    state: 'Karnataka',
    phrases: {
      en: [
        'Solar Power in Mangalore - Bringing Power to Your Home',
        'Affordable Solar Power in Mangalore - Lunar Electric',
        'Professional Solar Power Installation in Mangalore',
        'Solar Power in Mangalore - Reduce Your Electricity Bill'
      ],
      kn: [
        'ಮಂಗಳೂರಿನಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ಮನೆಗೆ ಶಕ್ತಿಯನ್ನು ತರುವುದು',
        'ಮಂಗಳೂರಿನಲ್ಲಿ ಅಗ್ಗದ ಸೌರಶಕ್ತಿ - ಲೂನಾರ್ ಎಲೆಕ್ಟ್ರಿಕ್',
        'ಮಂಗಳೂರಿನಲ್ಲಿ ವೃತ್ತಿಪರ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆ',
        'ಮಂಗಳೂರಿನಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ವಿದ್ಯುತ್ ಬಿಲ್ ಕಡಿಮೆ ಮಾಡಿ'
      ]
    },
    description: 'Mangalore, the port city of Karnataka, is harnessing the power of the sun. With its coastal location receiving abundant sunlight, Mangalore is ideal for solar installations, helping residents and businesses save significantly on electricity bills.',
    keywords: 'solar companies in Mangalore, solar panel installation Mangalore, rooftop solar Mangalore, solar energy Mangalore, solar power Mangalore, best solar company Mangalore, solar installation services Mangalore, residential solar Mangalore, commercial solar Mangalore',
    faqs: [
      { q: 'Is corrosion a risk near the coast?', a: 'We use marine‑grade fasteners and anodized structures. Proper earthing and periodic rinse keep salt deposits in check, extending system life.' },
      { q: 'Can the system withstand coastal winds?', a: 'Yes. We engineer structures for local wind speeds and follow IS standards; your array stays safe during heavy gusts.' }
    ]
  },
  'Belagavi': {
    state: 'Karnataka',
    phrases: {
      en: [
        'Solar Power in Belagavi - Bringing Power to Your Home',
        'Affordable Solar Power in Belagavi - Lunar Electric',
        'Professional Solar Power Installation in Belagavi',
        'Solar Power in Belagavi - Reduce Your Electricity Bill'
      ],
      kn: [
        'ಬೆಳಗಾವಿಯಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ಮನೆಗೆ ಶಕ್ತಿಯನ್ನು ತರುವುದು',
        'ಬೆಳಗಾವಿಯಲ್ಲಿ ಅಗ್ಗದ ಸೌರಶಕ್ತಿ - ಲೂನಾರ್ ಎಲೆಕ್ಟ್ರಿಕ್',
        'ಬೆಳಗಾವಿಯಲ್ಲಿ ವೃತ್ತಿಪರ ಸೌರಶಕ್ತಿ ಸ್ಥಾಪನೆ',
        'ಬೆಳಗಾವಿಯಲ್ಲಿ ಸೌರಶಕ್ತಿ - ನಿಮ್ಮ ವಿದ್ಯುತ್ ಬಿಲ್ ಕಡಿಮೆ ಮಾಡಿ'
      ]
    },
    description: 'Belagavi, known for its industrial growth, is adopting solar energy solutions. With increasing electricity costs, Belagavi residents and industries are turning to solar power for sustainable and cost-effective energy solutions.',
    keywords: 'solar companies in Belagavi, solar panel installation Belagavi, rooftop solar Belagavi, solar energy Belagavi, solar power Belagavi, best solar company Belagavi, solar installation services Belagavi, residential solar Belagavi, commercial solar Belagavi',
    faqs: [
      { q: 'What savings can factories expect in Belagavi?', a: 'Most MSMEs see 30–60% reduction in daytime energy charges. Payback is typically 3–4 years with accelerated depreciation benefits.' }
    ]
  },
  'Mumbai': {
    state: 'Maharashtra',
    phrases: {
      en: [
        'Solar Power in Mumbai - Bringing Power to Your Home',
        'Affordable Solar Power in Mumbai - Lunar Electric',
        'Professional Solar Power Installation in Mumbai',
        'Solar Power in Mumbai - Reduce Your Electricity Bill'
      ],
      mr: [
        'मुंबईत सौर ऊर्जा - तुमच्या घरासाठी शक्ती आणणे',
        'मुंबईत स्वस्त सौर ऊर्जा - लुनार इलेक्ट्रिक',
        'मुंबईत व्यावसायिक सौर ऊर्जा स्थापना',
        'मुंबईत सौर ऊर्जा - तुमचे वीज बिल कमी करा'
      ]
    },
    description: 'Mumbai, the financial capital of India, is embracing solar energy to combat rising electricity costs. With limited rooftop space and high energy consumption, Mumbai residents and businesses are finding solar panels to be an excellent investment for long-term savings.',
    keywords: 'solar companies in Mumbai, solar panel installation Mumbai, rooftop solar Mumbai, solar energy Mumbai, solar power Mumbai, best solar company Mumbai, solar installation services Mumbai, residential solar Mumbai, commercial solar Mumbai',
    faqs: [
      { q: 'What if my society has limited roof space?', a: 'We optimize with high‑wattage modules and shared‑array designs for societies. Even a 20–30 kW plant on common areas meaningfully reduces society bills.' },
      { q: 'Do I need BMC permissions?', a: 'Residential RCC roofs typically need no special permission beyond DISCOM approvals. We handle the paperwork end‑to‑end.' }
    ]
  },
  'Pune': {
    state: 'Maharashtra',
    phrases: {
      en: [
        'Solar Power in Pune - Bringing Power to Your Home',
        'Affordable Solar Power in Pune - Lunar Electric',
        'Professional Solar Power Installation in Pune',
        'Solar Power in Pune - Reduce Your Electricity Bill'
      ],
      mr: [
        'पुण्यात सौर ऊर्जा - तुमच्या घरासाठी शक्ती आणणे',
        'पुण्यात स्वस्त सौर ऊर्जा - लुनार इलेक्ट्रिक',
        'पुण्यात व्यावसायिक सौर ऊर्जा स्थापना',
        'पुण्यात सौर ऊर्जा - तुमचे वीज बिल कमी करा'
      ]
    },
    description: 'Pune, the Oxford of the East, is leading Maharashtra\'s solar revolution. With its educated population and growing IT sector, Pune residents are increasingly adopting solar energy for both environmental and economic benefits.',
    keywords: 'solar companies in Pune, solar panel installation Pune, rooftop solar Pune, solar energy Pune, solar power Pune, best solar company Pune, solar installation services Pune, residential solar Pune, commercial solar Pune',
    faqs: [
      { q: 'How fast is net‑metering with MSEDCL in Pune?', a: 'With complete documentation, the process is predictable. We manage submissions, inspections and meter changes to keep it moving without surprises.' },
      { q: 'Can I monitor generation on my phone?', a: 'Yes. You get app access for real‑time production, savings and alerts. We set it up during commissioning.' }
    ]
  },
  'Delhi': {
    state: 'Delhi',
    phrases: {
      en: [
        'Solar Power in Delhi - Bringing Power to Your Home',
        'Affordable Solar Power in Delhi - Lunar Electric',
        'Professional Solar Power Installation in Delhi',
        'Solar Power in Delhi - Reduce Your Electricity Bill'
      ],
      hi: [
        'दिल्ली में सोलर ऊर्जा - आपके घर के लिए बिजली लाना',
        'दिल्ली में सस्ती सोलर ऊर्जा - लुनार इलेक्ट्रिक',
        'दिल्ली में पेशेवर सोलर ऊर्जा स्थापना',
        'दिल्ली में सोलर ऊर्जा - अपने बिजली बिल को कम करें'
      ]
    },
    description: 'Delhi, the capital of India, is rapidly adopting solar energy to combat air pollution and reduce electricity costs. With government incentives and growing awareness, Delhi residents are switching to solar power for a cleaner and more sustainable future.',
    keywords: 'solar companies in Delhi, solar panel installation Delhi, rooftop solar Delhi, solar energy Delhi, solar power Delhi, best solar company Delhi, solar installation services Delhi, residential solar Delhi, commercial solar Delhi',
    faqs: [
      { q: 'Does Delhi’s air quality reduce solar output?', a: 'Dust can settle on panels, but with a rinse every couple of weeks, your system performs near peak. We plan safe access and share an easy cleaning routine.' },
      { q: 'Are there subsidies or incentives in Delhi?', a: 'Subsidy policies evolve. We guide you on current central/state incentives and handle paperwork where applicable.' }
    ]
  },
  'Kolkata': {
    state: 'West Bengal',
    phrases: {
      en: [
        'Solar Power in Kolkata - Bringing Power to Your Home',
        'Affordable Solar Power in Kolkata - Lunar Electric',
        'Professional Solar Power Installation in Kolkata',
        'Solar Power in Kolkata - Reduce Your Electricity Bill'
      ],
      bn: [
        'কলকাতায় সৌরশক্তি - আপনার বাড়িতে শক্তি আনা',
        'কলকাতায় সাশ্রয়ী সৌরশক্তি - লুনার ইলেকট্রিক',
        'কলকাতায় পেশাদার সৌরশক্তি ইনস্টলেশন',
        'কলকাতায় সৌরশক্তি - আপনার বিদ্যুৎ বিল কমান'
      ]
    },
    description: 'Kolkata, the City of Joy, is embracing solar energy to reduce electricity bills and contribute to a greener environment. With increasing awareness about renewable energy, Kolkatans are choosing solar panels for sustainable living.',
    keywords: 'solar companies in Kolkata, solar panel installation Kolkata, rooftop solar Kolkata, solar energy Kolkata, solar power Kolkata, best solar company Kolkata, solar installation services Kolkata, residential solar Kolkata, commercial solar Kolkata',
    faqs: [
      { q: 'How does monsoon affect generation in Kolkata?', a: 'Cloudy days reduce output temporarily, but annual generation averages account for monsoons. A well‑sized system still delivers the promised yearly savings.' }
    ]
  },
  'Chennai': {
    state: 'Tamil Nadu',
    phrases: {
      en: [
        'Solar Power in Chennai - Bringing Power to Your Home',
        'Affordable Solar Power in Chennai - Lunar Electric',
        'Professional Solar Power Installation in Chennai',
        'Solar Power in Chennai - Reduce Your Electricity Bill'
      ],
      ta: [
        'சென்னையில் சூரிய சக்தி - உங்கள் வீட்டிற்கு ஆற்றலைக் கொண்டுவருதல்',
        'சென்னையில் மலிவான சூரிய சக்தி - லூனார் எலக்ட்ரிக்',
        'சென்னையில் தொழில்முறை சூரிய சக்தி நிறுவல்',
        'சென்னையில் சூரிய சக்தி - உங்கள் மின்சார பில் குறைக்க'
      ]
    },
    description: 'Chennai, the Gateway of South India, is harnessing solar energy to meet its growing power needs. With abundant sunshine throughout the year, Chennai is ideal for solar installations, helping residents save significantly on electricity costs.',
    keywords: 'solar companies in Chennai, solar panel installation Chennai, rooftop solar Chennai, solar energy Chennai, solar power Chennai, best solar company Chennai, solar installation services Chennai, residential solar Chennai, commercial solar Chennai',
    faqs: [
      { q: 'Will heat reduce panel efficiency in Chennai summers?', a: 'High‑efficiency modules with good temperature coefficients perform reliably. We optimize spacing and airflow to keep modules cooler and efficient.' }
    ]
  },
  'Coimbatore': {
    state: 'Tamil Nadu',
    phrases: {
      en: [
        'Solar Power in Coimbatore - Bringing Power to Your Home',
        'Affordable Solar Power in Coimbatore - Lunar Electric',
        'Professional Solar Power Installation in Coimbatore',
        'Solar Power in Coimbatore - Reduce Your Electricity Bill'
      ],
      ta: [
        'கோயம்புத்தூரில் சூரிய சக்தி - உங்கள் வீட்டிற்கு ஆற்றலைக் கொண்டுவருதல்',
        'கோயம்புத்தூரில் மலிவான சூரிய சக்தி - லூனார் எலக்ட்ரிக்',
        'கோயம்புத்தூரில் தொழில்முறை சூரிய சக்தி நிறுவல்',
        'கோயம்புத்தூரில் சூரிய சக்தி - உங்கள் மின்சார பில் குறைக்க'
      ]
    },
    description: 'Coimbatore, the Manchester of South India, is adopting solar energy for industrial and residential use. With its thriving textile and manufacturing industries, Coimbatore businesses are turning to solar power to reduce operational costs.',
    keywords: 'solar companies in Coimbatore, solar panel installation Coimbatore, rooftop solar Coimbatore, solar energy Coimbatore, solar power Coimbatore, best solar company Coimbatore, solar installation services Coimbatore, residential solar Coimbatore, commercial solar Coimbatore',
    faqs: [
      { q: 'Do textile units benefit from solar?', a: 'Yes—daytime consumption aligns well with solar generation, bringing predictable savings and reducing demand on DG sets.' }
    ]
  },
  'Hyderabad': {
    state: 'Telangana',
    phrases: {
      en: [
        'Solar Power in Hyderabad - Bringing Power to Your Home',
        'Affordable Solar Power in Hyderabad - Lunar Electric',
        'Professional Solar Power Installation in Hyderabad',
        'Solar Power in Hyderabad - Reduce Your Electricity Bill'
      ],
      te: [
        'హైదరాబాద్లో సౌరశక్తి - మీ ఇంటికి శక్తిని తీసుకురావడం',
        'హైదరాబాద్లో చౌకైన సౌరశక్తి - లూనార్ ఎలక్ట్రిక్',
        'హైదరాబాద్లో ప్రొఫెషనల్ సౌరశక్తి స్థాపన',
        'హైదరాబాద్లో సౌరశక్తి - మీ విద్యుత్ బిల్లును తగ్గించండి'
      ]
    },
    description: 'Hyderabad, the City of Pearls, is embracing solar energy to power its growing IT and pharma industries. With abundant sunshine and government support, Hyderabad residents and businesses are switching to solar for sustainable energy solutions.',
    keywords: 'solar companies in Hyderabad, solar panel installation Hyderabad, rooftop solar Hyderabad, solar energy Hyderabad, solar power Hyderabad, best solar company Hyderabad, solar installation services Hyderabad, residential solar Hyderabad, commercial solar Hyderabad',
    faqs: [
      { q: 'Can I start small and expand later?', a: 'Certainly. We design with expansion in mind—structure, inverter and strings planned so you can add capacity when needed.' }
    ]
  },
  'Ahmedabad': {
    state: 'Gujarat',
    phrases: {
      en: [
        'Solar Power in Ahmedabad - Bringing Power to Your Home',
        'Affordable Solar Power in Ahmedabad - Lunar Electric',
        'Professional Solar Power Installation in Ahmedabad',
        'Solar Power in Ahmedabad - Reduce Your Electricity Bill'
      ],
      gu: [
        'અમદાવાદમાં સોલર એનર્જી - તમારા ઘરમાં શક્તિ લાવવી',
        'અમદાવાદમાં સસ્તી સોલર એનર્જી - લૂનાર ઇલેક્ટ્રિક',
        'અમદાવાદમાં વ્યાવસાયિક સોલર એનર્જી સ્થાપના',
        'અમદાવાદમાં સોલર એનર્જી - તમારા વીજળી બિલ ઘટાડો'
      ]
    },
    description: 'Ahmedabad, the commercial capital of Gujarat, is leading the state\'s solar revolution. With its business-friendly environment and abundant sunshine, Ahmedabad is ideal for solar installations, helping businesses and homeowners save on electricity costs.',
    keywords: 'solar companies in Ahmedabad, solar panel installation Ahmedabad, rooftop solar Ahmedabad, solar energy Ahmedabad, solar power Ahmedabad, best solar company Ahmedabad, solar installation services Ahmedabad, residential solar Ahmedabad, commercial solar Ahmedabad',
    faqs: [
      { q: 'What is the typical payback in Ahmedabad?', a: 'Home systems recover costs in ~3–4 years; commercial plants often faster thanks to higher tariffs and accelerated depreciation.' }
    ]
  },
  'Surat': {
    state: 'Gujarat',
    phrases: {
      en: [
        'Solar Power in Surat - Bringing Power to Your Home',
        'Affordable Solar Power in Surat - Lunar Electric',
        'Professional Solar Power Installation in Surat',
        'Solar Power in Surat - Reduce Your Electricity Bill'
      ],
      gu: [
        'સુરતમાં સોલર એનર્જી - તમારા ઘરમાં શક્તિ લાવવી',
        'સુરતમાં સસ્તી સોલર એનર્જી - લૂનાર ઇલેક્ટ્રિક',
        'સુરતમાં વ્યાવસાયિક સોલર એનર્જી સ્થાપના',
        'સુરતમાં સોલર એનર્જી - તમારા વીજળી બિલ ઘટાડો'
      ]
    },
    description: 'Surat, the Diamond City of India, is adopting solar energy for its thriving textile and diamond industries. With high energy consumption, Surat businesses are finding solar panels to be a cost-effective solution for reducing operational expenses.',
    keywords: 'solar companies in Surat, solar panel installation Surat, rooftop solar Surat, solar energy Surat, solar power Surat, best solar company Surat, solar installation services Surat, residential solar Surat, commercial solar Surat',
    faqs: [
      { q: 'Can solar stabilize costs for textile units?', a: 'Yes. A right‑sized plant slashes daytime consumption from the grid, protecting margins from tariff hikes.' }
    ]
  },
  'Vizag': {
    state: 'Andhra Pradesh',
    phrases: {
      en: [
        'Solar Power in Vizag - Bringing Power to Your Home',
        'Affordable Solar Power in Vizag - Lunar Electric',
        'Professional Solar Power Installation in Vizag',
        'Solar Power in Vizag - Reduce Your Electricity Bill'
      ],
      te: [
        'విశాఖపట్నంలో సౌరశక్తి - మీ ఇంటికి శక్తిని తీసుకురావడం',
        'విశాఖపట్నంలో చౌకైన సౌరశక్తి - లూనార్ ఎలక్ట్రిక్',
        'విశాఖపట్నంలో ప్రొఫెషనల్ సౌరశక్తి స్థాపన',
        'విశాఖపట్నంలో సౌరశక్తి - మీ విద్యుత్ బిల్లును తగ్గించండి'
      ]
    },
    description: 'Visakhapatnam (Vizag), the Jewel of the East Coast, is harnessing solar energy to power its port city. With its coastal location and industrial growth, Vizag residents and businesses are adopting solar panels for sustainable and affordable energy.',
    keywords: 'solar companies in Vizag, solar panel installation Vizag, rooftop solar Vizag, solar energy Vizag, solar power Vizag, best solar company Vizag, solar installation services Vizag, residential solar Vizag, commercial solar Vizag, solar companies in Visakhapatnam',
    faqs: [
      { q: 'Is rusting a problem near the sea in Vizag?', a: 'We use corrosion‑resistant hardware and design for drainage so salt residue doesn’t sit on components. With simple rinsing, your system stays healthy for years.' }
    ]
  }
};

// Get city-specific content
export const getCityContent = (cityName, lang = 'en') => {
  const content = cityContentData[cityName];
  if (!content) return null;

  // Helper: pick FAQs by language if provided either as object map or array
  const selectFaqs = () => {
    const faqs = content.faqs;
    if (!faqs) return [];
    // If FAQs are defined per-language as an object, prefer requested lang, else fall back to 'en'
    if (Array.isArray(faqs)) {
      return faqs;
    }
    if (typeof faqs === 'object') {
      return faqs[lang] || faqs.en || [];
    }
    return [];
  };
  
  // Return content with phrases/faq in the requested language
  return {
    ...content,
    phrases: content.phrases && content.phrases[lang] ? content.phrases[lang] : (content.phrases?.en || []),
    faqs: selectFaqs()
  };
};
